import Box from '@zenbusiness/zui/Box';
import Skeleton from '@zenbusiness/zui/Skeleton';
import { superstyled } from '@zenbusiness/zui/styles';

export const LoadingSkeleton = superstyled({
  tag: Skeleton,
  name: 'SubscriptionRow',
  slot: 'LoadingSkeleton',
  styles: {
    width: '100%',
    height: 200,
    marginBlock: '0.75rem',
  },
});

export const RowContainer = superstyled({
  tag: Box,
  name: 'SubscriptionRow',
  slot: 'RowContainer',
  styles: {
    marginBlock: '0.75rem',
  },
});

export const IncludesContainer = superstyled({
  tag: Box,
  name: 'SubscriptionRow',
  slot: 'IncludesContainer',
  styles: ({ theme }) => ({
    width: '100%',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '1rem',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  }),
});
